export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/entra/identity/conditional-access/howto-conditional-access-policy-azure-management';
